var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.159,
    height: 283.683,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25313"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25083"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25067"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.664 126.343 71.825-48.056 70.76 105.759-71.825 48.056z",
    "data-name": "Rectangle 12009"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25070"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25068"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m119.143 179.06-.815 5.046-35.714-5.145.815-5.046z",
    "data-name": "Path 15813"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25069"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m101.161 161.06 5.125.738-5.682 35.163-5.125-.738z",
    "data-name": "Path 15814"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25074"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25073"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M68.266 116.367c.051.077-7.149 4.982-16.079 10.955s-16.215 10.756-16.266 10.679 7.147-4.981 16.081-10.956 16.212-10.758 16.264-10.678z",
    "data-name": "Path 15816"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25076"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25075"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M94.686 109.735c.051.077-11.921 8.174-26.738 18.084s-26.874 17.886-26.925 17.809 11.918-8.172 26.74-18.086 26.872-17.883 26.923-17.807z",
    "data-name": "Path 15817"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25078"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25077"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M99.982 117.653c.051.077-11.921 8.174-26.738 18.084s-26.874 17.886-26.925 17.809 11.918-8.172 26.74-18.086 26.872-17.883 26.923-17.807z",
    "data-name": "Path 15818"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25080"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25079"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M105.278 125.571c.051.077-11.921 8.174-26.738 18.084s-26.874 17.886-26.925 17.809 11.918-8.172 26.74-18.086 26.872-17.883 26.923-17.807z",
    "data-name": "Path 15819"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25082"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M110.574 133.487c.051.076-11.921 8.174-26.738 18.084s-26.874 17.886-26.925 17.809 11.918-8.172 26.74-18.086 26.872-17.882 26.923-17.807z",
    "data-name": "Path 15820"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25100"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25084"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "m265.401 189.543 60.336-40.356 59.423 88.842-60.336 40.356z",
    "data-name": "Rectangle 12010"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25087"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25085"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m353.988 233.817-.685 4.238-29.993-4.321.685-4.238z",
    "data-name": "Path 15821"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25086"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m338.883 218.7 4.3.62-4.772 29.531-4.3-.62z",
    "data-name": "Path 15822"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25091"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25090"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M311.257 181.166c.051.076-5.989 4.206-13.489 9.222s-13.624 9.023-13.675 8.946 5.987-4.205 13.49-9.223 13.622-9.024 13.674-8.945z",
    "data-name": "Path 15824"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25093"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25092"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M333.443 175.596c.051.076-10 6.887-22.44 15.21s-22.577 15.01-22.628 14.934 9.995-6.886 22.443-15.212 22.576-15.009 22.625-14.932z",
    "data-name": "Path 15825"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25095"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25094"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M337.893 182.245c.051.077-10 6.888-22.44 15.21s-22.577 15.011-22.628 14.934 9.995-6.885 22.442-15.211 22.576-15.009 22.626-14.933z",
    "data-name": "Path 15826"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25097"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25096"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M342.343 188.895c.051.077-10 6.887-22.441 15.21s-22.576 15.011-22.627 14.934 9.994-6.886 22.442-15.211 22.572-15.009 22.626-14.933z",
    "data-name": "Path 15827"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25099"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25098"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M346.788 195.545c.051.076-10 6.887-22.44 15.21s-22.576 15.01-22.628 14.934 9.995-6.886 22.443-15.212 22.574-15.009 22.625-14.932z",
    "data-name": "Path 15828"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25117"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m164.45 46.959 65.847 35.238-51.887 96.957-65.846-35.238z",
    "data-name": "Rectangle 12011"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25104"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25102"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m167.17 148.78-4.177 1.43-10.6-29.308 4.177-1.43z",
    "data-name": "Path 15829"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25103"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m173.573 127.754 1.521 4.206-29.107 9.968-1.521-4.206z",
    "data-name": "Path 15830"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25108"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25107"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M194.255 84.512c-.052.1-6.729-3.374-14.912-7.75s-14.778-8-14.727-8.1 6.728 3.374 14.914 7.752 14.777 8.002 14.725 8.098z",
    "data-name": "Path 15832"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25110"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25109"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M210.052 101.949c-.051.1-11.1-5.713-24.679-12.974s-24.546-13.228-24.494-13.325 11.1 5.712 24.681 12.976 24.544 13.227 24.492 13.323z",
    "data-name": "Path 15833"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25112"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25111"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M206.172 109.205c-.052.1-11.1-5.713-24.679-12.975s-24.546-13.228-24.495-13.324 11.1 5.712 24.682 12.975 24.544 13.227 24.492 13.324z",
    "data-name": "Path 15834"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25114"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25113"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M202.292 116.46c-.052.1-11.1-5.713-24.679-12.974s-24.547-13.228-24.495-13.325 11.1 5.712 24.681 12.976 24.544 13.227 24.493 13.323z",
    "data-name": "Path 15835"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25116"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25115"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M198.411 123.716c-.051.1-11.1-5.713-24.679-12.975s-24.546-13.228-24.495-13.324 11.1 5.712 24.682 12.975 24.544 13.227 24.492 13.324z",
    "data-name": "Path 15836"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M197.102 0h1.654v28.161h-1.654z",
    "data-name": "Rectangle 12012",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25120"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25119"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25118"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aab9cf",
    d: "M159.365 62.228h77.129s-7.122-34.085-39.151-34.085c-28.485 0-37.978 34.085-37.978 34.085z",
    "data-name": "Path 15837"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#aab9cf",
    d: "M197.102 0h1.654v28.161h-1.654z",
    "data-name": "Rectangle 12013"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25122"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25121"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M369.654 281.613c0 .092-82.756.166-184.818.166-102.1 0-184.836-.074-184.836-.166s82.739-.167 184.836-.167c102.062 0 184.818.075 184.818.167z",
    "data-name": "Path 15838"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25132"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25123"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ae7e",
    d: "M20.459 241.514a8.069 8.069 0 0 1 5.624 2.88 14.244 14.244 0 0 1 2.864 5.77c1.083 4.049.417 8.827-.738 12.856-4.383-1.567-7.086-6.241-8.308-8.7-1.932-3.884-3.064-12.077.558-12.807",
    "data-name": "Path 15839"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25124"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ae7e",
    d: "M34.516 267.927a6.886 6.886 0 0 1-.322-6.906 9.141 9.141 0 0 1 5.507-4.426 3.854 3.854 0 0 1 3.241.155 2.942 2.942 0 0 1 1.133 2.761 5.976 5.976 0 0 1-1.26 2.833c-2.132 2.885-4.724 5.287-8.3 5.583",
    "data-name": "Path 15840"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25126"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25125"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M34.999 281.456a4.718 4.718 0 0 1-.2-.841l-.451-2.307a24.174 24.174 0 0 1-.48-7.75 14.8 14.8 0 0 1 2.875-7.183 10.05 10.05 0 0 1 1.663-1.68 6.038 6.038 0 0 1 .522-.375c.122-.081.189-.119.195-.11a15.721 15.721 0 0 0-2.209 2.3 15.265 15.265 0 0 0-2.745 7.093 26.059 26.059 0 0 0 .39 7.672c.157.979.284 1.774.356 2.325a4.579 4.579 0 0 1 .084.856z",
    "data-name": "Path 15841"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25128"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25127"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M21.872 247.676a1.784 1.784 0 0 1 .177.332l.451.976c.388.85.932 2.086 1.592 3.62 1.321 3.066 3.086 7.328 4.928 12.078s3.412 9.09 4.5 12.245c.547 1.577.978 2.857 1.265 3.746l.324 1.025a1.745 1.745 0 0 1 .094.364 1.79 1.79 0 0 1-.152-.344c-.1-.26-.223-.594-.378-1.007l-1.355-3.713c-1.143-3.135-2.744-7.458-4.585-12.207s-3.573-9.018-4.843-12.1l-1.5-3.656c-.164-.409-.3-.74-.4-1a1.788 1.788 0 0 1-.118-.359z",
    "data-name": "Path 15842"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25129"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ae7e",
    d: "M29.796 272.505a16.107 16.107 0 0 0-12.5-7.766c-1.295-.094-2.854.124-3.432 1.287s.2 2.545 1.078 3.5a13.76 13.76 0 0 0 14.9 3.327",
    "data-name": "Path 15843"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25131"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25130"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M19.269 268.208a4.062 4.062 0 0 1 .812.03 7.749 7.749 0 0 1 .946.109c.365.068.79.108 1.242.234a14.256 14.256 0 0 1 1.477.41 16.021 16.021 0 0 1 1.646.626 17.911 17.911 0 0 1 3.469 2.056 17.6 17.6 0 0 1 2.867 2.837 15.33 15.33 0 0 1 1.01 1.444 13.051 13.051 0 0 1 .751 1.337 11.838 11.838 0 0 1 .516 1.154 7.255 7.255 0 0 1 .322.9 4.165 4.165 0 0 1 .211.784c-.065.022-.376-1.1-1.24-2.736a13.906 13.906 0 0 0-.772-1.3 16.273 16.273 0 0 0-1.016-1.4 18.188 18.188 0 0 0-2.835-2.771 18.607 18.607 0 0 0-3.4-2.042 16.687 16.687 0 0 0-1.611-.642 15.082 15.082 0 0 0-1.448-.44c-1.795-.463-2.954-.524-2.947-.59z",
    "data-name": "Path 15844"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25298"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25136"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25133"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M309.913 67.533c-1.883.434-2.8 2.6-2.978 4.523s.067 3.956-.741 5.71c-.909 1.976-3.081 3.432-3.153 5.605-.045 1.325.742 2.571.7 3.9-.062 2.177-2.282 3.822-2.4 6-.084 1.565.959 3.068.708 4.615-.2 1.2-1.133 2.154-1.529 3.308-.791 2.3.79 4.832 2.849 6.127a9.336 9.336 0 0 0 13.6-4.346c1.139-2.766.89-5.879.642-8.859q-1.156-13.932-1.719-27.9",
    "data-name": "Path 15845"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25135"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25134"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.443 100.308a2.249 2.249 0 0 0 .86-1.023 3.632 3.632 0 0 0 .22-1.563 8.711 8.711 0 0 0-.467-2.073 5.914 5.914 0 0 1-.335-2.625 6 6 0 0 1 1.526-2.621 5.834 5.834 0 0 0 .865-1.314 2.128 2.128 0 0 0 .1-1.535c-.331-1.046-1.356-1.816-1.826-3.023a3.264 3.264 0 0 1-.1-1.868 7.571 7.571 0 0 1 .618-1.676 14.379 14.379 0 0 0 1.272-3.013c.449-2.031.24-3.97.545-5.562A6.177 6.177 0 0 1 309.34 69a3.657 3.657 0 0 1 .846-.6 1.512 1.512 0 0 1 .339-.127 5.157 5.157 0 0 0-1.093.822 6.229 6.229 0 0 0-1.478 3.359 20.778 20.778 0 0 0-.178 2.587 15.811 15.811 0 0 1-.3 3.006 14.321 14.321 0 0 1-1.276 3.083 4.21 4.21 0 0 0-.5 3.287c.407 1.091 1.438 1.865 1.825 3.042a2.439 2.439 0 0 1-.119 1.76 6.092 6.092 0 0 1-.918 1.381 4.2 4.2 0 0 0-1.2 4.987 8.549 8.549 0 0 1 .427 2.13 3.659 3.659 0 0 1-.287 1.623 1.941 1.941 0 0 1-.656.808 1.053 1.053 0 0 1-.329.16z",
    "data-name": "Path 15846"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#b78876",
    d: "m299.406 115.487-5.78 16.662-24.1 1.292-4.019 8.943 25.163 2.546a9.507 9.507 0 0 0 12.582-5.579l6.715-18.745z",
    "data-name": "Path 15847"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25141"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25139"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25137"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b78876",
    d: "M349.26 272.565s-17.663-56.1-18.038-57.921c-.339-1.647 6.41-42.018 7.26-52.466l-23.866.89v.174l-10.144.562 9.085 114.734h10.983l-1.089-38.065a370.668 370.668 0 0 0 16.478 36.71z",
    "data-name": "Path 15848"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25138"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a36957",
    d: "M323.897 254.116c.01-.349-.133-12.754-.133-12.754-.137.742-4.21-10.771-4.112-11.471.051-.363 4.245 24.225 4.245 24.225z",
    "data-name": "Path 15849"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25140"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a36957",
    d: "M319.188 224.44a2.591 2.591 0 0 0-.071.7 18.717 18.717 0 0 0 .015 1.9c.015.4.057.841.109 1.312s.125.973.233 1.494a25.669 25.669 0 0 0 .9 3.343c.8 2.32 1.678 4.35 2.3 5.823l.765 1.735a2.6 2.6 0 0 0 .325.618 2.561 2.561 0 0 0-.194-.671 64.953 64.953 0 0 0-.657-1.778c-.563-1.5-1.4-3.544-2.195-5.844a28.859 28.859 0 0 1-.914-3.292c-.116-.512-.191-1.006-.263-1.467s-.12-.895-.152-1.292a36.386 36.386 0 0 1-.13-1.884 2.607 2.607 0 0 0-.071-.697z",
    "data-name": "Path 15850"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25173"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25172"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25143"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25142"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M313.349 279.104v-1.032l11.249-.49.031 4.255-.694.047c-3.088.18-15.713.7-17.78.082-2.312-.692 7.194-2.862 7.194-2.862z",
    "data-name": "Path 15851"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25145"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25144"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.782 281.579a1.015 1.015 0 0 1-.192.022l-.553.035-2.034.1a197.742 197.742 0 0 1-13.434.059l-2.034-.077-.553-.031a1.124 1.124 0 0 1-.192-.019.922.922 0 0 1 .193-.008h.554l2.035.034c1.718.029 4.092.055 6.715.044s4.995-.059 6.713-.1l2.035-.052.554-.009a1.15 1.15 0 0 1 .193.002z",
    "data-name": "Path 15852"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25147"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25146"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M309.705 281.942a2.96 2.96 0 0 0-1.08-1.746 1.808 1.808 0 0 1 1.08 1.746z",
    "data-name": "Path 15853"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25149"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25148"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M313.001 280.254c-.031.021-.19-.171-.354-.428s-.272-.481-.24-.5.19.172.354.428.272.48.24.5z",
    "data-name": "Path 15854"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25151"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25150"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M313.906 279.772c-.025.028-.2-.089-.4-.262s-.33-.335-.3-.363.2.089.4.262.325.335.3.363z",
    "data-name": "Path 15855"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25153"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25152"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M314.475 278.713a2.546 2.546 0 1 1-.586-.059 1.345 1.345 0 0 1 .586.059z",
    "data-name": "Path 15856"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25155"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M314.669 277.968a1.143 1.143 0 0 1-.651.192 1.13 1.13 0 0 1-.673-.088 3.689 3.689 0 0 1 .662-.048 3.606 3.606 0 0 1 .662-.056z",
    "data-name": "Path 15857"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25157"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25156"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M312.618 279.279a2.044 2.044 0 0 1-.719 0 4.2 4.2 0 0 1-.767-.165 2.1 2.1 0 0 1-.438-.18.383.383 0 0 1-.179-.222.283.283 0 0 1 .108-.288 1.317 1.317 0 0 1 1.632.38 1.281 1.281 0 0 1 .236.479.393.393 0 0 1 .02.194 2.023 2.023 0 0 0-.33-.612 1.286 1.286 0 0 0-.616-.4 1.111 1.111 0 0 0-.857.061c-.114.085-.069.219.059.294a2.162 2.162 0 0 0 .4.172 5.137 5.137 0 0 0 .742.19c.434.076.709.075.709.097z",
    "data-name": "Path 15858"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25159"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M312.432 279.316a.712.712 0 0 1-.085-.5 1.185 1.185 0 0 1 .196-.529.72.72 0 0 1 .6-.368.285.285 0 0 1 .223.331.8.8 0 0 1-.121.322 2.163 2.163 0 0 1-.338.436 1.05 1.05 0 0 1-.411.293c-.012-.018.143-.13.341-.358a2.52 2.52 0 0 0 .3-.433c.1-.152.165-.425-.016-.458-.18-.016-.363.164-.472.308a1.17 1.17 0 0 0-.2.468 2.618 2.618 0 0 0-.017.488z",
    "data-name": "Path 15859"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25161"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25160"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.543 278.518c0 .025-.321-.03-.827.032a3.508 3.508 0 0 0-2.923 2.347c-.169.481-.184.8-.21.8a.673.673 0 0 1 0-.226 2.939 2.939 0 0 1 .12-.6 3.4 3.4 0 0 1 3.005-2.413 2.91 2.91 0 0 1 .615.014.658.658 0 0 1 .22.046z",
    "data-name": "Path 15860"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25163"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25162"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M319.155 280.687a9.2 9.2 0 0 1-3.271.017c0-.039.735.009 1.636 0s1.631-.056 1.635-.017z",
    "data-name": "Path 15861"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25165"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25164"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M321.343 280.664c.027.027-.059.155-.133.323s-.115.317-.153.315-.059-.177.029-.37.238-.295.257-.268z",
    "data-name": "Path 15862"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25167"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25166"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M322.171 279.632c.027.026-.045.143-.16.261s-.231.192-.258.166.045-.143.161-.261.229-.192.257-.166z",
    "data-name": "Path 15863"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25169"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25168"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M323.352 279.158c-.008.038-.156.037-.32.1s-.283.147-.312.122.063-.181.268-.25.375-.007.364.028z",
    "data-name": "Path 15864"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25171"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25170"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.193 278.933c.014.035-.05.092-.143.129s-.179.037-.192 0 .05-.093.143-.129.179-.035.192 0z",
    "data-name": "Path 15865"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25204"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25175"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25174"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m339.706 278.112-.427-.94 10.064-5.055 1.771 3.869-.614.327c-2.743 1.429-14.047 7.076-16.186 7.358-2.388.316 5.392-5.559 5.392-5.559z",
    "data-name": "Path 15866"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25177"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25176"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M351.15 275.687a1.08 1.08 0 0 1-.167.1l-.489.259-1.817.919c-1.539.766-3.68 1.8-6.068 2.881s-4.574 2.02-6.163 2.676l-1.888.763-.517.2a1.071 1.071 0 0 1-.183.061 1.044 1.044 0 0 1 .173-.086l.507-.222 1.871-.8c1.579-.677 3.755-1.626 6.144-2.71s4.532-2.1 6.082-2.844l1.835-.881.5-.235a.913.913 0 0 1 .18-.081z",
    "data-name": "Path 15867"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25179"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25178"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M337.543 282.193a4.623 4.623 0 0 0-.747-.727 4.559 4.559 0 0 0-.953-.423 1.807 1.807 0 0 1 1.7 1.15z",
    "data-name": "Path 15868"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25181"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25180"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M339.86 279.304c-.021.031-.244-.079-.5-.246s-.445-.327-.424-.359.243.079.5.246.444.327.424.359z",
    "data-name": "Path 15869"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25183"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25182"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M340.487 278.493c-.011.036-.221 0-.468-.077s-.438-.17-.427-.206.221 0 .468.077.439.17.427.206z",
    "data-name": "Path 15870"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25185"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25184"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M340.573 277.294c.016.034-.209.173-.5.309a1.315 1.315 0 0 1-.559.186c-.016-.034.209-.172.5-.309a1.332 1.332 0 0 1 .559-.186z",
    "data-name": "Path 15871"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25187"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25186"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M340.443 276.535c.026.025-.181.259-.515.441a1.13 1.13 0 0 1-.65.2 3.754 3.754 0 0 1 .585-.315 3.545 3.545 0 0 1 .58-.326z",
    "data-name": "Path 15872"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25189"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25188"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M339.111 278.571a2.076 2.076 0 0 1-.657.293 4.167 4.167 0 0 1-.767.162 2.085 2.085 0 0 1-.474.017.388.388 0 0 1-.254-.13.284.284 0 0 1-.02-.307 1.32 1.32 0 0 1 1.645-.322 1.3 1.3 0 0 1 .412.34c.077.1.1.165.1.169a2.034 2.034 0 0 0-.552-.423 1.3 1.3 0 0 0-.724-.11 1.116 1.116 0 0 0-.757.407c-.069.124.027.228.174.245a2.237 2.237 0 0 0 .44-.01 4.959 4.959 0 0 0 .754-.13c.421-.109.671-.221.68-.201z",
    "data-name": "Path 15873"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25191"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25190"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M338.956 278.68a.7.7 0 0 1-.282-.42 1.192 1.192 0 0 1-.038-.56.723.723 0 0 1 .394-.581c.161-.049.536.274.562.395s-.19.058-.2.159a2.191 2.191 0 0 1-.129.537 1.036 1.036 0 0 1-.255.435c-.019-.011.077-.177.164-.466a2.47 2.47 0 0 0 .1-.518c.027-.179-.024-.455-.2-.411s-.264.3-.3.474a1.187 1.187 0 0 0 .007.51 2.517 2.517 0 0 0 .177.446z",
    "data-name": "Path 15874"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25193"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25192"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M349.677 272.987c.008.024-.3.1-.74.368a3.5 3.5 0 0 0-1.706 3.338c.043.508.161.808.137.816a.64.64 0 0 1-.094-.206 2.942 2.942 0 0 1-.138-.6 3.4 3.4 0 0 1 1.753-3.432 2.9 2.9 0 0 1 .567-.239.639.639 0 0 1 .221-.045z",
    "data-name": "Path 15875"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25195"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25194"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M345.651 277.178a9.154 9.154 0 0 1-2.976 1.356c-.013-.037.673-.293 1.492-.668s1.464-.722 1.484-.688z",
    "data-name": "Path 15876"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25197"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25196"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M347.643 276.258c.036.014.009.166.011.35s.025.335-.011.349-.126-.137-.125-.349.091-.364.125-.35z",
    "data-name": "Path 15877"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25198"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M347.97 274.98c.035.013.017.149-.04.3s-.131.27-.166.257-.018-.149.039-.3.132-.27.167-.257z",
    "data-name": "Path 15878"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25200"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M348.853 274.063c.009.038-.127.1-.253.219s-.2.249-.235.238-.016-.19.142-.337.342-.156.346-.12z",
    "data-name": "Path 15879"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25203"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25202"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M349.529 273.513c.026.027-.008.106-.078.177s-.148.107-.175.081.008-.105.078-.176.148-.108.175-.082z",
    "data-name": "Path 15880"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25228"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25218"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25217"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25210"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25209"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25208"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25207"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25206"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ae7e",
    d: "m336.935 143.187-1.874-22.856 9.623.171s.446-3.37-.972-10.762a12.478 12.478 0 0 0-7.274-8.965v-.061l-.293-.077a27.5 27.5 0 0 0-8.814-2.3l-11.811.137s-9.023-1.126-14.017 5.306c-1.924 2.478-7.877 19.436-7.877 19.436l14.177 6.828-1.349-9.4s.268 6.818 1.138 8.979c.485 1.2 1.888 4.94 1.888 4.94l-.183 11.278z",
    "data-name": "Path 15881"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25211"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87ae7e",
    d: "m330.418 117.015-1.753 7.469h16.539l-1.088-12.522z",
    "data-name": "Path 15882"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25213"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25212"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M345.204 124.487a12.333 12.333 0 0 0-2.189-.217c-1.355-.079-3.231-.146-5.3-.137s-3.949.1-5.3.207a11.765 11.765 0 0 0-2.184.27 14.837 14.837 0 0 0 2.2-.012c1.354-.042 3.224-.09 5.291-.1s3.938.016 5.293.03a14.078 14.078 0 0 0 2.189-.041z",
    "data-name": "Path 15883"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25215"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25214"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M329.705 111.9a9.925 9.925 0 0 0-.055 1.9c.013 1.172.055 2.79.124 4.576s.153 3.4.231 4.573a9.791 9.791 0 0 0 .2 1.89 9.93 9.93 0 0 0 .055-1.9c-.012-1.172-.055-2.79-.124-4.577s-.153-3.4-.231-4.572a9.79 9.79 0 0 0-.2-1.89z",
    "data-name": "Path 15884"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25216",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.655 118.369s3.677 27.256 14.01 26.534c0 0 4.653-.055 6.149-3.147v-1.218z",
    "data-name": "Path 15885"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25219",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.705 113.507-1.978 13.361 1.281 2.344 2.108-4.584-.892-.021z",
    "data-name": "Path 15886"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25220"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M309.481 134.561a2.766 2.766 0 0 1-.28-.638 39.13 39.13 0 0 1-.621-1.789 54.157 54.157 0 0 1-1.581-6.048 43.433 43.433 0 0 1-.784-6.205c-.039-.8-.051-1.447-.039-1.895a2.807 2.807 0 0 1 .048-.7c.053 0 .089.987.226 2.574a57.4 57.4 0 0 0 .876 6.156 77.913 77.913 0 0 0 1.48 6.044q.3 1.068.519 1.817a2.871 2.871 0 0 1 .156.684z",
    "data-name": "Path 15887"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25223"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M313.659 142.393c-.088.027-.344-.561-.571-1.313a3.18 3.18 0 0 1-.253-1.41c.089-.027.344.561.572 1.313a3.187 3.187 0 0 1 .252 1.41z",
    "data-name": "Path 15888"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25225"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25224"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M315.088 142.287a5.9 5.9 0 0 1-.059-3.995 13.352 13.352 0 0 1 .014 2 13.47 13.47 0 0 1 .045 1.995z",
    "data-name": "Path 15889"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25227"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25226"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M308.091 130.358c-.041.082-3.341-1.483-7.368-3.5s-7.262-3.711-7.22-3.794 3.339 1.483 7.369 3.5 7.26 3.712 7.219 3.794z",
    "data-name": "Path 15890"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25277"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25259"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25258"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25257"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25256"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25255"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25231"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25230"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25229"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b78876",
    d: "M313.905 100.687c.073-3.239.092-6.651.092-6.651s-4.155-.8-4.879-6.267c-.69-5.213 1.241-17.446 1.241-17.446 6.068-2.294 12.375-.214 16.533 4.7l-1.032 26.3a5.645 5.645 0 0 1-6.109 5.228 5.963 5.963 0 0 1-5.846-5.864z",
    "data-name": "Path 15891"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25239"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25234"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25233"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25232"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M310.043 80.099a.7.7 0 0 0 .655.721.667.667 0 0 0 .736-.611.7.7 0 0 0-.654-.722.669.669 0 0 0-.737.612z",
    "data-name": "Path 15892"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25238"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25237"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25236"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25235"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M309.783 79.181c.085.093.624-.284 1.375-.263s1.292.411 1.376.321c.041-.039-.043-.206-.279-.387a1.912 1.912 0 0 0-1.1-.37 1.848 1.848 0 0 0-1.1.323c-.231.172-.312.334-.272.376z",
    "data-name": "Path 15893"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25247"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25242"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25241"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M317.666 80.573a.7.7 0 0 0 .655.722.668.668 0 0 0 .736-.611.7.7 0 0 0-.654-.722.669.669 0 0 0-.737.611z",
    "data-name": "Path 15894"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25246"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25245"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25244"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25243"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M317.616 79.656c.084.094.624-.284 1.374-.263s1.292.412 1.376.322c.041-.04-.042-.206-.278-.388a1.926 1.926 0 0 0-1.1-.37 1.841 1.841 0 0 0-1.1.324c-.231.171-.314.334-.272.375z",
    "data-name": "Path 15895"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25251"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25250"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25249"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25248"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M314.743 85.158a4.912 4.912 0 0 0-1.214-.252c-.192-.025-.372-.067-.4-.2a.98.98 0 0 1 .142-.566q.289-.688.605-1.446a24.95 24.95 0 0 0 1.373-3.788 25.149 25.149 0 0 0-1.674 3.669c-.2.508-.4.992-.582 1.456a1.114 1.114 0 0 0-.119.75.483.483 0 0 0 .309.288 1.285 1.285 0 0 0 .324.054 4.92 4.92 0 0 0 1.236.035z",
    "data-name": "Path 15896"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25254"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25253"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25252"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a36957",
    d: "M313.997 94.035a13.849 13.849 0 0 0 7.341-1.757s-1.866 3.694-7.3 3.044z",
    "data-name": "Path 15897"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25261"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25260"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M320.021 77.487c-.155.235-.726.131-1.366.015s-1.208-.242-1.265-.517.6-.629 1.452-.465 1.335.747 1.179.967z",
    "data-name": "Path 15898"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25263"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25262"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M312.55 76.387c-.058.274-.67.374-1.376.41s-1.324-.015-1.407-.282.512-.68 1.362-.717 1.481.322 1.421.589z",
    "data-name": "Path 15899"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25264"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a36957",
    d: "M314.757 86.956a.381.381 0 0 0-.416.19.427.427 0 1 0 .256-.2",
    "data-name": "Path 15900"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25266"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25265"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M314.933 87.03c.034-.03-.12-.215-.448-.143a.569.569 0 0 0-.411.4.643.643 0 0 0 .226.68.631.631 0 0 0 .72.005.54.54 0 0 0 .231-.534c-.066-.338-.315-.391-.322-.345-.029.043.087.16.065.359a.289.289 0 0 1-.153.236.33.33 0 0 1-.325-.014.342.342 0 0 1-.115-.31.327.327 0 0 1 .173-.238c.178-.097.336-.05.359-.096z",
    "data-name": "Path 15901"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25276"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25267"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M324.376 81.448c-.648 1.5-2.228 2.658-2.009 4.278.141 1.046.812 2.021.682 3.068-.164 1.315-1.531 2.227-1.724 3.538-.237 1.608 1.327 2.858 1.952 4.359.91 2.185-.254 4.643-.281 7.01a7.517 7.517 0 0 0 6.655 7.311 4.06 4.06 0 0 0 3.866-1.577c.625-1.036.5-2.352.875-3.5.559-1.713 2.192-2.967 2.536-4.736.628-3.225-3.27-5.894-3.013-9.169.109-1.4.973-2.621 1.341-3.976a5.823 5.823 0 0 0-1.144-5.181c-.962-1.144-2.357-1.9-3.177-3.146-.929-1.417-.961-3.215-1.311-4.873a12.276 12.276 0 0 0-19.5-7.191s-.931 4.22 3.4 4.925 6.339-.108 6.827 1.628a4.594 4.594 0 0 0 1.3 3.966c1.792 1.934 3.475 1.529 2.725 3.266z",
    "data-name": "Path 15902"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25269"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25268"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.288 110.717a1.773 1.773 0 0 1-.395-.042 5.833 5.833 0 0 1-1.1-.3 7.769 7.769 0 0 1-3.352-2.481 8.768 8.768 0 0 1-1.424-2.536 10.152 10.152 0 0 1-.583-3.287 13.418 13.418 0 0 1 .462-3.657 15.981 15.981 0 0 1 .613-1.852 18.555 18.555 0 0 0 .7-1.839 3.472 3.472 0 0 0-.006-1.878 10.277 10.277 0 0 0-.729-1.753 11.871 11.871 0 0 1-.746-1.735 3.749 3.749 0 0 1-.134-1.84 13.061 13.061 0 0 1 1.42-3.015 5.741 5.741 0 0 0 .58-2.728 6.454 6.454 0 0 0-1.428-3.777 11.576 11.576 0 0 0-1.088-1.059 4.427 4.427 0 0 1 1.186.975 6.414 6.414 0 0 1 1.565 3.851 5.914 5.914 0 0 1-.566 2.858 13.219 13.219 0 0 0-1.367 2.953 5.392 5.392 0 0 0 .871 3.372 10.443 10.443 0 0 1 .756 1.811 3.8 3.8 0 0 1 .008 2.051 18.284 18.284 0 0 1-.717 1.876 15.8 15.8 0 0 0-.605 1.813 13.224 13.224 0 0 0-.47 3.568 9.235 9.235 0 0 0 1.884 5.682 7.894 7.894 0 0 0 3.215 2.506c.905.37 1.458.425 1.45.463z",
    "data-name": "Path 15903"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25271"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25270"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M330.651 78.408a4.536 4.536 0 0 1-.954.142 9.942 9.942 0 0 1-2.638-.07 5.008 5.008 0 0 1-3.327-2.019 10.821 10.821 0 0 1-.874-2.149 3.545 3.545 0 0 0-1.458-1.8 10.381 10.381 0 0 0-4.491-1.172 7.8 7.8 0 0 1-3.732-1.163 3.7 3.7 0 0 1-1.528-2.138 2.287 2.287 0 0 1-.049-.722.735.735 0 0 1 .052-.247 4.74 4.74 0 0 0 .123.937 3.688 3.688 0 0 0 1.537 1.977 7.781 7.781 0 0 0 3.633 1.05 10.421 10.421 0 0 1 4.636 1.2 3.86 3.86 0 0 1 1.582 1.962 11.006 11.006 0 0 0 .827 2.1 4.839 4.839 0 0 0 3.115 1.954 11.207 11.207 0 0 0 2.584.171 6.377 6.377 0 0 1 .962-.013z",
    "data-name": "Path 15904"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25273"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25272"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.062 73.193a1.949 1.949 0 0 1-.75.111 4.6 4.6 0 0 1-3.212-1.283 6.1 6.1 0 0 1-.993-1.325c-.578-.974-1.133-2.175-2.33-2.671a7.648 7.648 0 0 0-3.588-.316 11 11 0 0 1-3.061-.025 3.817 3.817 0 0 1-1.89-.848 2.146 2.146 0 0 1-.376-.422.925.925 0 0 1-.1-.173c.026-.021.179.2.554.495a3.932 3.932 0 0 0 1.846.715 11.528 11.528 0 0 0 3-.048 7.7 7.7 0 0 1 3.748.317 3.69 3.69 0 0 1 1.533 1.267 16.986 16.986 0 0 1 .932 1.552 6.037 6.037 0 0 0 .923 1.284 4.413 4.413 0 0 0 1.1.813 4.757 4.757 0 0 0 1.918.536c.475.029.742-.008.746.021z",
    "data-name": "Path 15905"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25275"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25274"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M333.199 109.335c-.032-.015.171-.427.408-1.215a11.052 11.052 0 0 0 .427-3.432 10.562 10.562 0 0 0-1.366-4.889c-.468-.838-1.18-1.585-1.759-2.506a4.525 4.525 0 0 1-.645-1.546 3.5 3.5 0 0 1 .141-1.728 20.14 20.14 0 0 0 1.141-3.053 4.212 4.212 0 0 0-.831-2.776 13.077 13.077 0 0 1-.686-1.272 4.63 4.63 0 0 1-.362-1.337 11.88 11.88 0 0 1 .073-2.442 6.454 6.454 0 0 0-.3-3.4 3.077 3.077 0 0 0-.755-1s.029.007.077.036a1.281 1.281 0 0 1 .2.146 2.371 2.371 0 0 1 .591.763 6.343 6.343 0 0 1 .422 3.479 12.015 12.015 0 0 0-.033 2.388 6.075 6.075 0 0 0 1.038 2.487 8.344 8.344 0 0 1 .7 1.36 3.23 3.23 0 0 1 .193 1.617 19 19 0 0 1-1.146 3.108 3.169 3.169 0 0 0-.133 1.568 4.238 4.238 0 0 0 .6 1.433c.549.885 1.265 1.647 1.748 2.526a10.566 10.566 0 0 1 1.335 5.037 10.377 10.377 0 0 1-.538 3.477 7.669 7.669 0 0 1-.369.884 1.224 1.224 0 0 1-.171.287z",
    "data-name": "Path 15906"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25287"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25278"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b5175",
    d: "M307.118 228.636s-4.312-40.877-4.56-55.982 6.791-30.007 6.791-30.007l27.586-1.167s5.452 15.326 5.55 21.763c.189 12.51-3.324 24.864-2.919 34.788l.922 30.6",
    "data-name": "Path 15907"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25280"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25279"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M341.411 178.387a3.731 3.731 0 0 1-.45.341l-.252.178c-.086.073-.17.165-.267.258a4.089 4.089 0 0 0-.614.687 15.258 15.258 0 0 0-2.158 5.472 18.47 18.47 0 0 1-1.4 3.889 7.07 7.07 0 0 1-.612.968c-.12.153-.229.318-.361.466l-.424.424a6.857 6.857 0 0 1-2.075 1.331c-1.544.677-3.288 1-4.88 1.8a7.708 7.708 0 0 0-3.54 4.036c-.777 1.734-1.248 3.556-1.9 5.256a9.517 9.517 0 0 1-2.88 4.367 7.9 7.9 0 0 1-4.514 1.415c-1.485.087-2.861.044-4.094.231a6.468 6.468 0 0 0-3.088 1.165 4.3 4.3 0 0 0-1.434 2.021 3.016 3.016 0 0 0-.107 1.569c.071.36.172.532.149.541a1.639 1.639 0 0 1-.215-.525 2.986 2.986 0 0 1 .048-1.624 4.385 4.385 0 0 1 1.443-2.127 6.6 6.6 0 0 1 3.169-1.253c1.256-.205 2.647-.176 4.111-.274a7.65 7.65 0 0 0 4.346-1.383 9.266 9.266 0 0 0 2.761-4.238c.637-1.681 1.105-3.506 1.9-5.278a8.016 8.016 0 0 1 3.7-4.19c1.656-.822 3.4-1.134 4.9-1.788a6.591 6.591 0 0 0 2-1.264l.408-.4c.127-.14.232-.3.348-.444a6.735 6.735 0 0 0 .6-.93 18.475 18.475 0 0 0 1.412-3.821 14.854 14.854 0 0 1 2.284-5.488 4.075 4.075 0 0 1 .649-.681c.1-.09.192-.18.282-.25l.265-.167a3.522 3.522 0 0 1 .49-.29z",
    "data-name": "Path 15908"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25282"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25281"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M341.581 159.467a3.5 3.5 0 0 1 .036.547 6.752 6.752 0 0 1-.192 1.564 10.109 10.109 0 0 1-3.116 4.819 18.492 18.492 0 0 1-3.231 2.359c-1.235.734-2.6 1.432-4 2.221a20.926 20.926 0 0 0-4.089 2.875 15.792 15.792 0 0 0-3.1 4.353 40.189 40.189 0 0 1-2.686 4.731 11.334 11.334 0 0 1-1.751 1.936 11.046 11.046 0 0 1-2.082 1.387 25.822 25.822 0 0 1-4.286 1.643c-1.369.423-2.646.8-3.762 1.265a14.752 14.752 0 0 0-2.869 1.537 8.929 8.929 0 0 0-1.8 1.661 8.621 8.621 0 0 0-1.081 1.8 3.384 3.384 0 0 1 .178-.519 6.34 6.34 0 0 1 .8-1.357 8.758 8.758 0 0 1 1.794-1.732 14.547 14.547 0 0 1 2.887-1.6c1.125-.488 2.408-.878 3.77-1.312a26 26 0 0 0 4.226-1.651 10.852 10.852 0 0 0 2.018-1.356 11.146 11.146 0 0 0 1.693-1.886 40.805 40.805 0 0 0 2.656-4.7 16.01 16.01 0 0 1 3.167-4.433 20.982 20.982 0 0 1 4.162-2.9c1.41-.787 2.775-1.474 4.008-2.192a18.56 18.56 0 0 0 3.211-2.295 10.207 10.207 0 0 0 3.15-4.678 9.906 9.906 0 0 0 .289-2.087z",
    "data-name": "Path 15909"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25284"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25283"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M302.698 174.819c-.006 0-.025-.039-.056-.124a2.969 2.969 0 0 1-.125-.381 3.064 3.064 0 0 1 .065-1.535 6.276 6.276 0 0 1 4.055-3.739c1.135-.39 2.423-.625 3.766-.977a7.052 7.052 0 0 0 5.218-3.883 19.686 19.686 0 0 0 .956-2.3 25.089 25.089 0 0 1 2.03-4.91 7.842 7.842 0 0 1 4.177-3.247 38.113 38.113 0 0 1 4.793-1.214 15.882 15.882 0 0 0 4.167-1.42 8.715 8.715 0 0 0 2.82-2.54 9.522 9.522 0 0 0 1.792-5.187 14.752 14.752 0 0 0-.136-2.046 6.745 6.745 0 0 1 .266 2.049 9.459 9.459 0 0 1-1.73 5.321 8.908 8.908 0 0 1-2.877 2.645 15.966 15.966 0 0 1-4.236 1.477 38.965 38.965 0 0 0-4.747 1.221 7.525 7.525 0 0 0-4.008 3.119 25.124 25.124 0 0 0-2.005 4.842 19.891 19.891 0 0 1-.981 2.337 7.323 7.323 0 0 1-5.432 4c-1.361.344-2.642.564-3.761.933a6.205 6.205 0 0 0-4.005 3.553 3.135 3.135 0 0 0-.123 1.484c.074.341.131.517.117.522z",
    "data-name": "Path 15910"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25286"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25285"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M339.209 209.387a1.869 1.869 0 0 1 .044.4 4.29 4.29 0 0 1-.118 1.156 6.579 6.579 0 0 1-2.42 3.459 10.788 10.788 0 0 1-2.539 1.507 33.658 33.658 0 0 1-3.188 1.1 26.287 26.287 0 0 0-3.463 1.264 10.013 10.013 0 0 0-3.151 2.3c-.934.978-1.74 2.047-2.634 2.99a12.043 12.043 0 0 1-2.951 2.31 12.964 12.964 0 0 1-6.089 1.583 12.068 12.068 0 0 1-4.191-.7 7.751 7.751 0 0 1-1.064-.456 1.844 1.844 0 0 1-.352-.195 1.778 1.778 0 0 1 .38.134 10.706 10.706 0 0 0 1.077.394 12.641 12.641 0 0 0 4.146.583 12.931 12.931 0 0 0 5.947-1.612 11.836 11.836 0 0 0 2.863-2.265c.876-.929 1.678-2 2.631-3a10.256 10.256 0 0 1 3.253-2.363 25.9 25.9 0 0 1 3.512-1.263c1.132-.344 2.208-.664 3.171-1.064a10.733 10.733 0 0 0 2.5-1.437 6.614 6.614 0 0 0 2.441-3.307 7.722 7.722 0 0 0 .195-1.518z",
    "data-name": "Path 15911"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25290"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b78876",
    d: "m336.064 124.511-5.333.126a8.728 8.728 0 0 1-1.207 3.026 92.1 92.1 0 0 1-8.777-22.284c.126-.416.274-.877.459-1.392a5.916 5.916 0 0 0-.071-2.344c-.149-.928-.409-2.177-.487-2.755-.238-1.762-.521-2.038-1.136-1.839-.836.271.343 4.947-.342 5.048-.368.055-.818-1.547-.949-2.862s-.725-5.358-1.159-5.627c-.637-.395-1.193.23-1.032 1.539.163 1.325.369 5.275-.326 5.329s-1.259-6.651-1.259-6.651.108-1.459-.7-1.424c-1.451.063-.318 7.131-.193 7.8.087.466-.667.551-.733.046-.069-.521-.419-6.7-1.9-6.654-1.133.038.878 5.824.242 7.165s-1.079-4.555-2.161-4.474c-.4.03-.7.109.04 3.446a74.97 74.97 0 0 0 2.588 7.82c1.715 9.252 9.244 38.85 21.046 33.432 6.6-3.031 9.284-16.468 9.284-16.468z",
    "data-name": "Path 15912"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25289"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a36957",
    d: "M313.304 100.654a.353.353 0 0 0 .153-.021.342.342 0 0 0 .241-.37c-.015-.4-.077-.976-.169-1.725a24.5 24.5 0 0 1-.295-2.728c-.009-.536.005-1.112.036-1.722a5.94 5.94 0 0 1 .093-.923c.05-.289.244-.621.468-.582l.025.005h.011c.228-.01.406.167.479.439a2.52 2.52 0 0 1 .084.857v.02a51.738 51.738 0 0 0 .685 5.346c.051.239.1.48.179.723a3.619 3.619 0 0 0 .133.367 1.126 1.126 0 0 0 .109.189.346.346 0 0 0 .267.168.478.478 0 0 0 .4-.336 1.96 1.96 0 0 0 .12-.393 5.987 5.987 0 0 0 .1-.782 23.243 23.243 0 0 0-.043-3.2 7.3 7.3 0 0 1-.066-1.6.879.879 0 0 1 .315-.6.347.347 0 0 1 .275-.035.667.667 0 0 1 .152.066.215.215 0 0 1 .071.1 8.008 8.008 0 0 1 .444 1.609c.113.567.212 1.144.3 1.728s.173 1.175.243 1.77a12.241 12.241 0 0 0 .295 1.821 6.091 6.091 0 0 0 .289.905 1.653 1.653 0 0 0 .263.453.382.382 0 0 0 .384.139.411.411 0 0 0 .261-.287 3.16 3.16 0 0 0 .068-1c-.014-.318-.04-.632-.067-.946-.046-.539-.1-1.073-.115-1.6a5.3 5.3 0 0 1 .019-.77 1.186 1.186 0 0 1 .078-.334.292.292 0 0 1 .061-.1c.01-.011.017-.006.025-.016l.083-.024c.425-.175.566.416.679.892.1.5.161 1.01.261 1.515.168 1.008.383 2.01.5 2.974a3.443 3.443 0 0 1-.056 1.378l-.45 1.373-.013.041.01.043a74.048 74.048 0 0 0 2.864 9.258c1.014 2.732 2.027 5.093 2.922 7.024s1.692 3.422 2.245 4.438l.666 1.145a2.639 2.639 0 0 0 .248.384 2.8 2.8 0 0 0-.2-.413l-.617-1.17c-.521-1.031-1.29-2.531-2.152-4.472s-1.852-4.3-2.842-7.036a76.152 76.152 0 0 1-2.8-9.227v.084l.449-1.355a3.713 3.713 0 0 0 .078-1.532c-.114-1-.323-1.974-.491-2.988-.1-.5-.159-1.015-.262-1.539a3.023 3.023 0 0 0-.262-.793.687.687 0 0 0-.858-.376l-.108.03a.556.556 0 0 0-.145.082.63.63 0 0 0-.162.228 1.581 1.581 0 0 0-.107.437 5.735 5.735 0 0 0-.022.826c.019.543.071 1.08.117 1.618.026.313.052.624.066.93a3.007 3.007 0 0 1-.048.861c-.016.067-.047.054-.011.087v.024-.007a.051.051 0 0 1 0-.022c0-.006.017-.028.009-.03a.089.089 0 0 1-.038-.035 1.341 1.341 0 0 1-.2-.347 5.806 5.806 0 0 1-.271-.85 11.9 11.9 0 0 1-.289-1.775 49.129 49.129 0 0 0-.557-3.527 7.946 7.946 0 0 0-.487-1.71.575.575 0 0 0-.2-.225.973.973 0 0 0-.238-.1.693.693 0 0 0-.541.075 1.2 1.2 0 0 0-.474.833 3.045 3.045 0 0 0-.01.878c.032.273.058.541.079.811a23.248 23.248 0 0 1 .059 3.154 5.65 5.65 0 0 1-.093.739 1.745 1.745 0 0 1-.1.332.452.452 0 0 1-.07.12c-.024.053-.044-.013-.042.074.033-.066 0-.029-.024-.084a1 1 0 0 1-.076-.133 3.037 3.037 0 0 1-.121-.328 8.429 8.429 0 0 1-.177-.7 53.1 53.1 0 0 1-.724-5.305v.021a2.762 2.762 0 0 0-.1-.952.966.966 0 0 0-.251-.427.663.663 0 0 0-.474-.173h.035a.552.552 0 0 0-.552.265 1.383 1.383 0 0 0-.2.5 6.081 6.081 0 0 0-.085.962 24.77 24.77 0 0 0-.01 1.737 22.782 22.782 0 0 0 .353 2.741c.112.744.2 1.321.231 1.711a.3.3 0 0 1-.187.335c-.077.047-.13.053-.128.06z",
    "data-name": "Path 15913"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#b78876",
    d: "M271.605 133.326a13.762 13.762 0 0 0-3.709.426c-3.306.87-9.014 4.329-9.251 8.6h4.146s-2.322 4.942-1.639 4.485a53.337 53.337 0 0 0 5.294-4.769z",
    "data-name": "Path 15914"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25297"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25292"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25291"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M328.159 58.933c-.092.008-.468-3.419-.841-7.655s-.6-7.677-.508-7.685.468 3.419.841 7.656.6 7.676.508 7.684z",
    "data-name": "Path 15915"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25294"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25293"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M346.348 43.802c.075.053-2.727 4.119-6.256 9.079s-6.453 8.941-6.528 8.887 2.725-4.118 6.256-9.08 6.453-8.94 6.528-8.886z",
    "data-name": "Path 15916"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25296"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25295"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M353.905 62.227c.018.091-3.251.839-7.3 1.671s-7.35 1.434-7.368 1.344 3.249-.838 7.3-1.671 7.349-1.434 7.368-1.344z",
    "data-name": "Path 15917"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25303"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25299"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7a89a0",
    d: "m136.143 150.173-22.641 116.4-2.964 15.239 151.147-.746c6.783-.033 12.794-6.056 14.977-15.005l26.8-109.9c1.657-6.793-1.978-13.859-7.127-13.854l-152.978.161c-3.38.011-6.334 3.162-7.214 7.705z",
    "data-name": "Path 15918"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25301"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aab9cf",
    d: "m247.182 258.687-16-128.957a10.149 10.149 0 0 0-9.834-9.209l-35.092.114a9.565 9.565 0 0 0-6.932 3.074l-16.663 17.713-97.6.509c-5.964.031-10.546 5.675-9.756 12.015l14.859 119.19a10.149 10.149 0 0 0 9.821 9.2L250.074 282c18.943.392 20.752-5.2 20.752-5.2-21.708 4.814-23.642-18.096-23.644-18.113z",
    "data-name": "Path 15920"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 25302",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.843 232.88-5.736 6.161-44.181-39.745 5.736-6.161z",
    "data-name": "Path 15921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.701 191.769 6.34 5.7-39.976 42.938-6.34-5.7z",
    "data-name": "Path 15922"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25312"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25308"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25305"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25304"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e5c",
    d: "M271.47 66.451a1.2 1.2 0 0 1-.724-1.048l-.256-5.944a1.194 1.194 0 0 1 1.468-1.214 3.708 3.708 0 0 0 2.891-.571 3.34 3.34 0 0 0 1.494-2.187 3.422 3.422 0 0 0-.719-2.571 3.811 3.811 0 0 0-2.523-1.519 4.477 4.477 0 0 0-4.545 3.225 1.195 1.195 0 0 1-2.306-.626 6.884 6.884 0 0 1 7.125-4.973 6.16 6.16 0 0 1 4.155 2.452 5.815 5.815 0 0 1 1.171 4.4 5.734 5.734 0 0 1-2.526 3.791 6.243 6.243 0 0 1-3.24 1.058l.2 4.582a1.2 1.2 0 0 1-1.664 1.15z",
    "data-name": "Path 15923"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25307"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25306"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e5c",
    d: "M273.221 68.879a.977.977 0 1 1-1.042-.908.977.977 0 0 1 1.042.908z",
    "data-name": "Path 15924"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25311"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25310"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25309"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M250.895 58.069a2.434 2.434 0 0 0 .058-.39l.126-1.144a13.447 13.447 0 0 1 .309-1.841c.084-.359.128-.757.26-1.161s.257-.836.4-1.293a22 22 0 0 1 3.184-6.1 21.465 21.465 0 0 1 19.845-8.353c.491.047.975.178 1.468.264a9.927 9.927 0 0 1 1.473.355 20.362 20.362 0 0 1 5.727 2.6 21.426 21.426 0 0 1 8.463 10.629 20.894 20.894 0 0 1 1.255 7.3 20.516 20.516 0 0 1-1.339 7.518l-.289.731-.038.1.039.09 4.707 10.842.269-.306-9.588-3.684-.119-.046-.093.09a21.434 21.434 0 0 1-9.055 5.228 21.305 21.305 0 0 1-17.288-2.683 21.938 21.938 0 0 1-5.4-5.028 23.532 23.532 0 0 1-2.951-5.351 23.784 23.784 0 0 1-1.145-4.466q-.114-.937-.2-1.666-.02-.717-.032-1.223a251.91 251.91 0 0 1-.025-.75 1.286 1.286 0 0 0-.021-.255 1.36 1.36 0 0 0-.015.254c0 .188-.006.436-.01.752v1.23l.169 1.679a23.319 23.319 0 0 0 1.1 4.522 23.562 23.562 0 0 0 2.935 5.442 22.094 22.094 0 0 0 5.438 5.135 21.569 21.569 0 0 0 17.55 2.8 21.786 21.786 0 0 0 9.237-5.3l-.212.045 9.583 3.7.484.187-.214-.493-4.7-10.844v.186l.3-.746a20.964 20.964 0 0 0 1.368-7.686 21.326 21.326 0 0 0-1.29-7.465 21.8 21.8 0 0 0-8.65-10.825 20.67 20.67 0 0 0-5.838-2.625 10.264 10.264 0 0 0-1.5-.357c-.5-.085-1-.217-1.494-.263a21.476 21.476 0 0 0-23.251 14.783q-.2.693-.381 1.31c-.126.408-.164.811-.242 1.173a12.672 12.672 0 0 0-.27 1.858l-.083 1.153a2.62 2.62 0 0 0-.014.388z",
    "data-name": "Path 15925"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllNoData);
export default __webpack_public_path__ + "static/media/All_NoData.4d1f3bf89cdbede8e88a774b0ffba1f7.svg";
export { ForwardRef as ReactComponent };